import styled from "styled-components";

const StyledEspaco = styled.div`
    width: 100%;
    height: 30vh;
`;

export {StyledEspaco}